var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",on:{"click":_vm.exportList}},[_vm._v("下载全部")])}
var staticRenderFns = []

export { render, staticRenderFns }